import React, { useState, useContext } from "react";
import { Radio, Typography, Row, Col } from "antd";
import { Field } from "../../metadata/Field";
import { VehicleTypeBtn } from './VehicleTypeBtn';
import { TooltipHint } from "../../metadata/TooltipHint";
import {FormContext} from '../../metadata/MDForm';
import Form from 'antd/lib/form'
import { GlobalStateContext } from "../../../context/GlobalStateProvider";

const { Text } = Typography;

export function VehicleIdentifier({
  attr: attrId,
  dataType,
  label,
  component,
  hintDescriptionVIN,
  hintDescriptionManual,
  ...props
}) {
  const [radioValue, setRadioValue] = useState(1);
  const { isDesktop, changeSummaryLayout: changeRadioLayout } = useContext(GlobalStateContext)

  const onChange = e => {
    setRadioValue(e.target.value)
  };
  return (
    <React.Fragment>
      <VehicleTypeBtn />
      <Row style={{marginTop: '22px', marginBottom: '22px'}}>
        <Row style={{width:"100%"}} role="group" aria-label={label}>
        <Col span={isDesktop ? 4 : 24} style={{ marginBottom: isDesktop ? '' : '6px' }}>
          <Text>{label}</Text>
        </Col>
        <Col span={isDesktop ? 20 : 24}>
          <Radio.Group
            onChange={onChange}
            name='radiogroup'
            defaultValue={1}
            style={{
              display: 'flex',
              flexDirection: changeRadioLayout ? 'column' : 'row'
            }}
          >
            <Radio 
              value={1}
              style={{
                padding: changeRadioLayout ? '4px 4px' : ''
              }}
            >
              Select from List
            </Radio>
            <Radio 
              value={2}
              style={{
                padding: changeRadioLayout ? '4px 4px' : ''
              }}
            >
              I Know My VIN <TooltipHint hintText={hintDescriptionVIN}/>
            </Radio>
            <Radio 
              value={3}
              style={{
                padding: changeRadioLayout ? '4px 4px' : ''
              }}
            >
              Enter Manually <TooltipHint hintText={hintDescriptionManual}/>
            </Radio>
          </Radio.Group>
        </Col>
        </Row>
      </Row>
      {radioValue === 1 && <SelectFromList />}
      {radioValue === 2 && <VINChooseSelection />}
      {radioValue === 3 && <ManuallyEnter />}
    </React.Fragment>
  );
}


function SelectFromList(props) {
    const { getValueByAttr, setValueByAttr } = useContext(FormContext);
    const vehicleAttrs = {
        yearAttr: 'Vehicle.ModelYr',
        makeAttr: 'Vehicle.Manufacturer',
        modelAttr: 'Vehicle.Model',
        vinAttr: 'Vehicle.VehIdentificationNumber'
    };
    const [ vehicle, setVehicle ] = useState({
        year: getValueByAttr(vehicleAttrs.yearAttr),
        make: getValueByAttr(vehicleAttrs.makeAttr),
        model: getValueByAttr(vehicleAttrs.modelAttr) });

    const updateYear = newYear => {
        const newVehicle = { year: newYear, make: undefined, model: undefined };
        setVehicle(newVehicle);
        setValueByAttr(vehicleAttrs.yearAttr, newYear);
        setValueByAttr(vehicleAttrs.makeAttr, undefined);
        setValueByAttr(vehicleAttrs.modelAttr, undefined);
        //setValueByAttr(vehicleAttrs.vinAttr, undefined); // ???
    }
    const updateMake = newMake => {
        const newVehicle = { year: vehicle.year, make: newMake, model: undefined };
        setVehicle(newVehicle);
        setValueByAttr(vehicleAttrs.makeAttr, newMake);
        setValueByAttr(vehicleAttrs.modelAttr, undefined);
        //setValueByAttr(vehicleAttrs.vinAttr, undefined); // ???
    }
    const updateModel = newModel => {
        const newVehicle = { year: vehicle.year, make: vehicle.make, model: newModel };
        setVehicle(newVehicle);
        setValueByAttr(vehicleAttrs.modelAttr, newModel);
    }

    const vehicleYearSelectComponent = {
            VehicleYearSelect: { year: vehicle.year, yearAttr: vehicleAttrs.yearAttr, vinAttr: vehicleAttrs.vinAttr, onchange: updateYear }
          };
    const vehicleMakeSelectComponent = {
            VehicleMakeSelect: { year: vehicle.year, make: vehicle.make, vinAttr: vehicleAttrs.vinAttr, onchange: updateMake }
          };
    const vehicleModelSelectComponent = {
            VehicleModelSelect: { year: vehicle.year, make: vehicle.make, model: vehicle.model, vinAttr: vehicleAttrs.vinAttr, onchange: updateModel }
          };
    return (
        <React.Fragment>
          <Field style={{flexDirection: 'row'}} attr={'Vehicle.ModelYr'} label={'Year'} component={vehicleYearSelectComponent}/>
          <Field style={{flexDirection: 'row'}} attr={'Vehicle.Manufacturer'} label={'Make'} yearAttr={'Vehicle.ModelYr'} component={vehicleMakeSelectComponent}/>
          <Field style={{flexDirection: 'row'}} attr={'Vehicle.Model'} label={'Model'} component={vehicleModelSelectComponent}/>
        </React.Fragment>
    );
}

export function ManuallyEnter(props) {
  return (
    <React.Fragment>
      <Field attr={'Vehicle.ModelYr'} label={'Year'} dataType="string" type='number'/>
      <Field attr={'Vehicle.Manufacturer'} label={'Make'} yearAttr={'Vehicle.ModelYr'} dataType="string"/>
      <Field attr={'Vehicle.Model'} label={'Model'} dataType="string"/>
    </React.Fragment>
  );
}


export function VINChooseSelection(props) {
  let { getValueByAttr } = useContext(FormContext);
  const VINComponent = {
          VINChoose: {
            modelAttr: "Vehicle.Model",
            yearAttr: "Vehicle.ModelYr",
            makeAttr: "Vehicle.Manufacturer",
            bodyStyleAttr: "Vehicle.bodyStyle",
            antiTheftAttr: "Vehicle.AntiTheftCd",
            antiLockAttr: "Vehicle.AntiBrakingSystemCd",
            restraintAttr: "Vehicle.RestraintCd"
          }
        }
    const yearDisplay = getValueByAttr("Vehicle.ModelYr");
    const makeDisplay = getValueByAttr("Vehicle.Manufacturer");
    const modelDisplay = getValueByAttr("Vehicle.Model");
  return (
    <React.Fragment>
      <Field attr={'Vehicle.VehIdentificationNumber'} label={'VIN'} component={VINComponent}/>
      {yearDisplay && (
        <Form.Item label='Year' labelCol={{ span: 4 }}>
          {yearDisplay}
        </Form.Item>
      )}
      {makeDisplay && (
        <Form.Item label='Make' labelCol={{ span: 4 }}>
          {makeDisplay}
        </Form.Item>
      )}
      {modelDisplay && (
        <Form.Item label='Model' labelCol={{ span: 4 }}>
          {modelDisplay}
        </Form.Item>
      )}
    </React.Fragment>
  );
}
